import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import {Observable, map, of, catchError, throwError} from 'rxjs';
import {Router} from "@angular/router";
import {CommonService} from "../service/common.service";
import { TokenStorageService } from '../service/token-storage.service';

@Injectable()
export class ErrorInterceptorInterceptor implements HttpInterceptor {

    constructor(
        private tokenStorageService: TokenStorageService,
        private router: Router,
        private common: CommonService
    ) {

    }

    intercept(request: HttpRequest < unknown > , next: HttpHandler): Observable < HttpEvent < unknown >> {
        let token = this.tokenStorageService.getToken();

        request = request.clone({
            headers: request.headers.set("Authorization", token ? `Bearer ${token}` : '')
        })
        console.log('error inter calles');
        return next.handle(request).pipe(
            catchError(x=> this.handleAuthError(x)),
            map((res: any) => {
                return res;
            }));
    }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 401 || err.status === 403) {
            this.common.hide();
            this.tokenStorageService.removeData();
            this.router.navigate([`admin/login`]);
        }
        return throwError(() => err);
    }
}
